export default __webpack_public_path__ + "static/media/btn-play-store.a1220d37.png";